import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { feedbackFormHOC, useFeedbackHandlers, FeedbackFormContent } from './FeedbackForm';
import ButtonLink from '../common/appActions/appActionsItems/ButtonLink';
import ConfirmationModal from '../common/ConfirmationModal';
import Icon from '../common/Icon';

const DesktopFeedback = (props) => {
    const [modalVisible, setModalVisible] = useState(false);
    const { content, charactersLeft, handleContentChange, sendFeedback } = useFeedbackHandlers(
        props.appId,
        props.dispatchFeedback
    );
    if (!props.user) {
        return null;
    }

    return (
        <div className={`ast-app-feedback ${props.className}`}>
            <ButtonLink className="ast-app-details__footer-link" action={() => setModalVisible(true)}>
                <Icon alias="mail-send" />
                &nbsp;<span>Submit feedback</span>
            </ButtonLink>
            {modalVisible && (
                <ConfirmationModal
                    className="ast-app-feedback__modal"
                    confirmLabel="Ok"
                    closeHandler={() => setModalVisible(false)}
                    title={
                        <div className="ast-app-feedback__title">
                            <span className="sg-modal-title">Submit feedback</span>
                            <img className="ast-app-feedback__title-logo" src={props.appLogo} />
                        </div>
                    }
                    confirmHandler={() => {
                        sendFeedback();
                        setModalVisible(false);
                    }}
                    isDisabled={props.isFetching || content.length === 0}
                >
                    <FeedbackFormContent
                        content={content}
                        handleContentChange={handleContentChange}
                        charactersLeft={charactersLeft}
                    />
                </ConfirmationModal>
            )}
        </div>
    );
};

DesktopFeedback.propTypes = {
    user: PropTypes.bool.isRequired,
    appId: PropTypes.string.isRequired,
    dispatchFeedback: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    appLogo: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const DesktopFeedbackHOC = feedbackFormHOC(DesktopFeedback);

export default DesktopFeedbackHOC;
